export default __webpack_public_path__ + "img/bg_dsp_playlist-25e33bbee7a4bf996bf52d0cb3281df5.png";